export const worker = {
  namespaced: true,
  state: {
    worker: null,
    workerClone: null,
  },
};
